module.exports = __webpack_public_path__ + "img/tr.d8706561.svg";